import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import axios from 'axios';

// Initial state for cookie consent
const initialState = {
  analytics: false,
  marketing: false,
  personalization: false,
  externalMedia: false,
  isConsentGiven: false, // track if consent is given
  isPersonalizing: false, 
};

// Reducer to manage cookie consent
const cookieConsentSlice = createSlice({
  name: 'cookieConsent',
  initialState,
  reducers: {
    setCookieConsent: (state, action) => {
      const { analytics, marketing, personalization, externalMedia } = action.payload;
      state.analytics = analytics;
      state.marketing = marketing;
      state.personalization = personalization;
      state.externalMedia = externalMedia;
      state.isConsentGiven = true;

      // Store the consent data in cookies for persistence
      Cookies.set('cookieConsent', JSON.stringify(action.payload), { expires: 365 });
    },
    loadCookieConsent: (state) => {
      // Check if consent is already saved in cookies
      const storedConsent = Cookies.get('cookieConsent');
      if (storedConsent) {
        const parsedConsent = JSON.parse(storedConsent);
        state.analytics = parsedConsent.analytics;
        state.marketing = parsedConsent.marketing;
        state.personalization = parsedConsent.personalization;
        state.externalMedia = parsedConsent.externalMedia;
        state.isConsentGiven = true;
      }
    },
    togglePersonalization: (state) => {
      state.isPersonalizing = !state.isPersonalizing;
    },
  },
});

export const { setCookieConsent, loadCookieConsent, togglePersonalization } = cookieConsentSlice.actions;
export default cookieConsentSlice.reducer;
